export default {
  baseURL: "https://rgift.co.il/api",
  version: "1.3.2",
  // Web-push VAPID public key — must match the server's pushNotificationConfig.PUBLIC_KEY
  vapidPublicKey:
    "BFmmaEWHxScrXQQ0Lk3-Tp3WbMyebXmk4WI2g3yFyeTMyJxfqr4YtA_4xVcNh7YHSFVgFgpTqFk9mji3iIA6gKY",
};
